/* ============================================================
   Product page mode switch.

   Two product-page designs ship on this theme — "sticky" (the V5 Sticky
   Note page) and "afterhours" (the minimal After Hours page) — and the
   visitor picks. Each new product page starts with After Hours.

   This runs synchronously BEFORE either panel is parsed, so it can stamp
   <html data-pn-mode> and the inactive panel never paints (pn-mode.css
   hides it by that attribute). The single 3D deck is carried into the
   active panel's `.pn-deck-mount` on every switch.
   ============================================================ */
(function () {
  'use strict';
  var MODES = ['afterhours', 'sticky'], DEFAULT = 'afterhours';
  var chosen = DEFAULT;
  var html = document.documentElement;

  function narrow() {
    if (html.classList.contains('pn-phone')) return true;
    if (html.classList.contains('pn-ipad-landscape')) return false;
    var wrap = document.querySelector('.pnah-main');
    var width = (wrap && wrap.clientWidth) || Math.max(0, window.innerWidth - 4);
    var lock = Math.max(width, (window.screen && screen.availWidth) || 0) / 1376;
    return width < (911 + 465 * 0.35) * (isFinite(lock) && lock > 0 ? lock * 0.86 : 1);
  }

  function read() {
    var stacked = narrow();
    html.classList.toggle('pn-product-phone', stacked);
    return stacked ? DEFAULT : chosen;
  }

  function apply(mode, persist) {
    html.setAttribute('data-pn-mode', mode);
    if (persist) chosen = mode;

    var panels = document.querySelectorAll('[data-pn-mode-panel]');
    for (var i = 0; i < panels.length; i++) {
      panels[i].hidden = panels[i].getAttribute('data-pn-mode-panel') !== mode;
    }
    var picks = document.querySelectorAll('[data-pn-mode-pick]');
    for (var j = 0; j < picks.length; j++) {
      picks[j].setAttribute('aria-pressed',
        picks[j].getAttribute('data-pn-mode-pick') === mode ? 'true' : 'false');
    }

    /* one deck and one tracklist, whichever page is showing.
       paranoise-player.js renders the rows into #pn-tracklist-mount BY ID, so
       there can only be one; each panel provides a .pn-tracks-mount slot and
       the rendered node is carried into the active one. */
    var tt = document.querySelector('.pn-tt');
    var mount = document.querySelector('[data-pn-mode-panel="' + mode + '"] .pn-deck-mount');
    if (tt && mount && tt.parentElement !== mount) mount.appendChild(tt);
    var tl = document.getElementById('pn-tracklist-mount');
    var slot = document.querySelector('[data-pn-mode-panel="' + mode + '"] .pn-tracks-mount');
    if (tl && slot && tl.parentElement !== slot) slot.appendChild(tl);

    try { window.dispatchEvent(new CustomEvent('pn:mode', { detail: { mode: mode } })); } catch (e) {}
    if (tt) { try { window.dispatchEvent(new Event('resize')); } catch (e) {} }
  }

  window.PNMode = {
    get: function () { return html.getAttribute('data-pn-mode') || read(); },
    isStacked: narrow,
    set: function (m) { if (MODES.indexOf(m) > -1 && !narrow()) apply(m, true); }
  };

  /* the picker is fixed under the theme header; measure the header so it
     never sits on the header's bottom edge at other zoom levels */
  function placePicker() {
    var hdr = document.querySelector('sticky-header, .header-wrapper, #shopify-section-header');
    var pick = document.querySelector('.pn-mode-pick');
    if (!hdr || !pick) return;
    var b = hdr.getBoundingClientRect().bottom;
    if (b > 0) pick.style.top = Math.round(b + 10) + 'px';
  }
  /* crossing the breakpoint has to re-apply: a window narrowed past 1100px
     must switch to After Hours, and widening again must hand back the
     visitor's own choice */
  var wasNarrow = narrow();
  window.addEventListener('resize', function () {
    var n = narrow();
    if (n !== wasNarrow) { wasNarrow = n; apply(read(), false); }
  });
  window.addEventListener('pn:device-layout', function () {
    var n = narrow();
    if (n !== wasNarrow) { wasNarrow = n; apply(read(), false); }
    placePicker();
  });
  window.addEventListener('resize', placePicker);
  document.addEventListener('DOMContentLoaded', placePicker);
  setTimeout(placePicker, 300);

  apply(read(), false);                                   /* stamp <html> now */
  document.addEventListener('DOMContentLoaded', function () { apply(read(), false); });

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-pn-mode-pick]');
    if (!b) return;
    e.preventDefault();
    window.PNMode.set(b.getAttribute('data-pn-mode-pick'));
  });
})();



